<script setup lang="ts">
const display = useDisplay()
const i18nHead = useLocaleHead()
const { ogImage, favicon, title, description } = useHeaderInformation()
const { googleAdsenseId } = useCountryConfig()

useHead({
  title,
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs.lang,
  },
  link: [
    ...(i18nHead.value.link || []),
    { rel: 'icon', href: favicon, id: 'favicon' },
  ],
  meta: [
    ...(i18nHead.value.meta || []),
    { property: 'google-adsense-account', content: `${googleAdsenseId}` },
    { property: 'og:title', content: title.value },
    { property: 'description', content: description.value },
    { property: 'og:description', content: description.value },
    { property: 'og:image', content: ogImage },
    { property: 'twitter:card', content: 'summary_large_image' },
  ],
  script: [
    { src: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js' },
  ],
})
</script>

<template>
  <Html>
    <Body>
      <v-app>
        <LayoutAppBar />
        <v-main>
          <v-container class="main-container" fluid>
            <slot />
          </v-container>
        </v-main>

        <LayoutFooter />
        <GeneralScrollButton />
        <AppSnackbar :class="!display.mdAndUp.value ? 'mb-16' : null" />
      </v-app>
    </Body>
  </Html>
</template>

<style>
.main-container {
  padding: 24px;
  max-width: 1920px;
}
</style>
